const AppConfig = {
    // 线上地址
    INTER_BASE:"https://2025.service.awards.tbifestival.com/index.php",
    INTER_IMPORT_CASE:"https://2025.service.awards.tbifestival.com/index.php?f=A_uploadCase&token=",//案例导入
    INTER_IMPORT_RATER:"https://2025.service.awards.tbifestival.com/index.php?f=A_uploadJudges&token=",//评委导入

    // INTER_BASE:"//localhost:8000/index.php",
    // INTER_IMPORT_CASE:"//localhost:8000/index.php?f=A_uploadCase&token=",//案例导入
    // INTER_IMPORT_RATER:"//localhost:8000/index.php?f=A_uploadJudges&token=",//评委导入

    // INTER_BASE:"//api.awards.topdigitalworld.com/index.php",
    // INTER_IMPORT_CASE:"//api.awards.topdigitalworld.com/index.php?f=A_uploadCase&token=",//案例导入
    // INTER_IMPORT_RATER:"//api.awards.topdigitalworld.com/index.php?f=A_uploadJudges&token=",//评委导入

    // 测试地址
    // INTER_BASE:"http://192.168.101.31:9000/index.php",
    // INTER_IMPORT_CASE:"http://192.168.101.31:9000/index.php?f=A_uploadCase&token=",//案例导入
    // INTER_IMPORT_RATER:"http://192.168.101.31:9000/index.php?f=A_uploadJudges&token=",//评委导入

}


export default AppConfig;